(function ($) {

    var _updateCookieExp = function (settings) {
        app.cookie.set(settings.LandingSiteCookieName, new Date(), { expires: settings.LandingSiteCookieTimeSpan, expires_time_mode: app.cookie.expires_time_mode.minute });
    };

    $(function () {
        var settings = $('[id$="siteData"]').data('general');

        if (!settings.LandingSiteCookieTimeSpan) return;

        if (settings.LandingSiteCookieName && document.cookie.indexOf(settings.LandingSiteCookieName + '=') < 0) {
            api.sendLandingSiteEvent({
                pageUrl: location.href
            }).done(function () {
                _updateCookieExp(settings);
            });
        } else {
            _updateCookieExp(settings);
        }

    });

})(jQuery);